import React from 'react'
import SignUpDetailsVendor from './SignUpDetailsVendor'

const SignUpVendorBody = () => {
  return (
    <div className="view-qualities folded router-view-container">
      <SignUpDetailsVendor />
    </div>  
  )
}

export default SignUpVendorBody